<div class="dialog-container">
  <div class="page search-page">
    <div class="flex-page-body" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="searchResultsScrolled()" [scrollWindow]="false" [infiniteScrollDisabled]="searchInfiniteScrollDisabled">
      <span class="page-title">{{data.promptText}}</span>
      <div class="search-input-container">
        <input #search debounce type="text" class="search-input" [placeholder]="data.placeholderText || 'Search'" [delay]="500"
          [alwaysHandleEmpty]="true" (text)="searchInputChanged($event)" [disabled]="working"
          [(ngModel)]="searchInputValue" />
        <button mat-button class="text-button search-button" disabled>
          <img src="assets/content-icon/ic-02.svg" class="icon" />
        </button>
      </div>
      <div class="search-results">
        <div class="empty-state" *ngIf="searchResults && searchResults.length == 0 && !isLoadingSearchResults() && !customLoading && !shouldShowCustom()">
          {{data.noResultsText || 'No results found'}}
        </div>
        <div *ngIf="hasSearchResults() || shouldShowCustom()">
          <div *ngIf="shouldShowCustom()" class="result selectable" [ngClass]="{selected: customIsSelected(), disabled: working}"
            (click)="selectCustom()">
            <avatar *ngIf="data.getImage" class="avatar" text="?" [grey]="true"></avatar>
            <span class="name">{{customText}}</span>
          </div>
          <div class="result selectable" *ngFor="let result of searchResults"
            [ngClass]="{selected: searchResultIsSelected(result), disabled: working}"
            (click)="selectSearchResult(result)">
            <avatar *ngIf="data.getImage" class="avatar" [text]="data.getText(result)" [url]="data.getImage(result)"></avatar>
            <span class="name">{{data.getText(result)}}</span>
          </div>
        </div>
        <div *ngIf="isLoadingSearchResults() || (customLoading && !hasSearchResults())">
          <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" diameter="40"></mat-progress-spinner>
        </div>
      </div>
    </div>
    <div class="flex-page-bottom-bar buttons">
      <button mat-button class="rounded-button" [disabled]="!canUseSearchResult()" (click)="useSearchResult()">
        <span *ngIf="!working">{{data.confirmText || 'Confirm'}}</span>
        <mat-progress-spinner *ngIf="working" class="spinner" mode="indeterminate" diameter="23"></mat-progress-spinner>
      </button>
    </div>
  </div>
</div>